// extracted by mini-css-extract-plugin
export default {"rowContainer":"SpecialOrderRow_rowContainer__k7f44","orderDetails":"SpecialOrderRow_orderDetails__PywP6","nameText":"SpecialOrderRow_nameText__Ze6hN"};